import { FC, MouseEvent } from "react";
import SquareImageList from "../../../components/atoms/SquareImageList";
import KarteFileAttachmentList from "../../../components/features/KarteFileAttachmentList";
import { Values } from "./index";

interface ExistingImagesProps {
  existingImageAttachments: Values["existingImageAttachments"];
  setValue: (value: Values["existingImageAttachments"]) => void;
}

export const ExistingImages: FC<ExistingImagesProps> = ({
  existingImageAttachments,
  setValue,
}) => {
  const imageAttachments = existingImageAttachments.filter(
    (image) => !image.shouldBeDeleted,
  );

  const handleExistingImageAttachmentDelete =
    (index: number) => (e: MouseEvent) => {
      e.preventDefault();

      const visibleImageAttachments = existingImageAttachments.filter(
        (imageAttachment) => !imageAttachment.shouldBeDeleted,
      );
      visibleImageAttachments[index].shouldBeDeleted = true;

      setValue(existingImageAttachments);
    };

  return (
    <SquareImageList
      keys={imageAttachments.map((image) => image.id)}
      imageUrls={imageAttachments.map((image) => image.presignedUrl)}
      deletable={true}
      onDelete={handleExistingImageAttachmentDelete}
    />
  );
};

interface ExistingFilesProps {
  existingFileAttachments: Values["existingFileAttachments"];
  setValue: (value: Values["existingFileAttachments"]) => void;
}

export const ExistingFiles: FC<ExistingFilesProps> = ({
  existingFileAttachments,
  setValue,
}) => {
  const fileAttachments = existingFileAttachments.filter(
    (fileAttachment) => !fileAttachment.shouldBeDeleted,
  );

  const handleExistingFileAttachmentDelete =
    (index: number) => (e: MouseEvent) => {
      e.preventDefault();

      const visibleFileAttachments = existingFileAttachments.filter(
        (fileAttachment) => !fileAttachment.shouldBeDeleted,
      );
      visibleFileAttachments[index].shouldBeDeleted = true;

      setValue(existingFileAttachments);
    };

  return (
    <KarteFileAttachmentList
      fileAttachments={fileAttachments}
      keys={fileAttachments.map(
        (fileAttachment) =>
          `StudentKarteEditForm-KarteFileAttachmentList-${fileAttachment.id}`,
      )}
      deletable={true}
      onDelete={handleExistingFileAttachmentDelete}
    />
  );
};
